import { LineChart as BaseLineChart } from '../line-chart-base';
import styles from './styles.module.scss';
import type { Component } from './types';
import { drawChart } from './utils';

export const LineChart: Component = ({ data, categoryList, month }) => (
  <BaseLineChart
    chartClassName={styles.chartRoot}
    onChartDraw={({
      element,
    }) => {
      drawChart({
        data,
        categoryList,
        element,
        month,
      });
    }} />
);
